<div class="container">
  <form [formGroup]="form">

    <div class="card flex-auto">
      <div class="px-6 py-4 border-b flex items-center header-title">
        <h2 class="title m-0">{{"STREAM_EVENTS.EDIT" | translate }}</h2>
        <div class="flex-end">
          <button [matMenuTriggerFor]="languageFormMenu" mat-icon-button type="button" align="end">
            <mat-icon svgIcon="{{iconFormFlag}}"></mat-icon>
          </button>
          <mat-menu #languageFormMenu="matMenu" overlapTrigger="false">
            <button mat-menu-item (click)="changeFormLanguage('it')">
              <mat-icon svgIcon="flag:italy"></mat-icon>
              <span>Italiano</span>
            </button>
            <button mat-menu-item (click)="changeFormLanguage('en')">
              <mat-icon svgIcon="flag:united-states"></mat-icon>
              <span>English</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="px-6 py-4 flex flex-col">

        <div class="card px-6 py-4 flex flex-col subCards">
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto" *ngIf="formLang=='it'">
              <mat-label>{{"STREAM_EVENTS.TITLE" | translate }} {{"GLOBAL.ITA" | translate}}</mat-label>
              <input matInput formControlName="nome_it" required>
            </mat-form-field>
            <mat-form-field class="flex-auto" *ngIf="formLang=='en'">
              <mat-label>{{"STREAM_EVENTS.TITLE" | translate }} {{"GLOBAL.ENG" | translate}}</mat-label>
              <input matInput formControlName="nome_en" required>
            </mat-form-field>


          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"STREAM_EVENTS.CATEGORY" | translate }}</mat-label>
              <mat-select formControlName="category" required>
                <mat-option [value]="item.value" *ngFor="let item of categories">{{item.label}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-auto">
              <mat-label>{{"STREAM_EVENTS.DATE" | translate }}</mat-label>
              <input [matDatepicker]="datepickerRef" matInput formControlName="date" required />
              <mat-datepicker-toggle [for]="datepickerRef" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #datepickerRef></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"STREAM_EVENTS.HOUR_FROM" | translate }}</mat-label>
              <mat-select formControlName="hourFrom" required>
                <mat-option [value]="item" *ngFor="let item of hours">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-auto">
              <mat-label>{{"STREAM_EVENTS.HOUR_TO" | translate }}</mat-label>
              <mat-select formControlName="hourTo" required>
                <mat-option [value]="item" *ngFor="let item of hours">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto" *ngIf="formLang=='it'">
              <mat-label>{{"STREAM_EVENTS.DESCRIPTION" | translate }} {{"GLOBAL.ITA" | translate}}</mat-label>
              <textarea cols="30" rows="8" matInput formControlName="desc_it" required></textarea>
            </mat-form-field>
            <mat-form-field class="flex-auto" *ngIf="formLang=='en'">
              <mat-label>{{"STREAM_EVENTS.DESCRIPTION" | translate }}  {{"GLOBAL.ENG" | translate}}</mat-label>
              <textarea cols="30" rows="8" matInput formControlName="desc_en" required></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="bottoni">
          <button (click)="confirmClose()" class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
          <button mat-raised-button (click)="submit()" class="m-4 bottone-viola"
            [disabled]="form.invalid">{{"GLOBAL.EDIT" |
            translate}}</button>
        </div>
      </div>
    </div>
  </form>
</div>
